unit View.Fs_Prod_Fabricantes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewFs_Prod_FabricantesEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFs_Prod_FabricantesGet: TXDataWebClient;
    Fs_Prod_FabricantesDataset: TXDataWebDataSet;
    Fs_Prod_FabricantesDatasetid: TIntegerField;
    Fs_Prod_FabricantesDatasetnome: TStringField;
    Fs_Prod_FabricantesDatasetexcluido: TBooleanField;
    Fs_Prod_FabricantesDatasetinclusao: TDateTimeField;
    Fs_Prod_FabricantesDatasetalteracao: TDateTimeField;
    Fs_Prod_FabricantesDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientFs_Prod_FabricantesGetLoad(Response: TXDataClientResponse);
    procedure Fs_Prod_FabricantesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_FabricantesEdit: TFViewFs_Prod_FabricantesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_FabricantesEdit }

procedure TFViewFs_Prod_FabricantesEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(ednome) then
  begin
    TUtils.SetErroClass('lbnome', 'Preencha o nome!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Fs_Prod_FabricantesDataset.State in dsEditModes then
    begin
      Fs_Prod_FabricantesDataset.Post;
      Fs_Prod_FabricantesDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;


class function TFViewFs_Prod_FabricantesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFs_Prod_FabricantesEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbnome');
end;

procedure TFViewFs_Prod_FabricantesEdit.InsertEntity;
begin
  Fs_Prod_FabricantesDataset.Close;
  Fs_Prod_FabricantesDataset.SetJsonData('{}');
  Fs_Prod_FabricantesDataset.Open;
  Fs_Prod_FabricantesDataset.Insert;
end;

class function TFViewFs_Prod_FabricantesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_FabricantesEdit(AForm).FInserting := AInserting;
    TFViewFs_Prod_FabricantesEdit(AForm).FId := AId;
    TFViewFs_Prod_FabricantesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFs_Prod_FabricantesEdit(AForm).InsertEntity
    else
      TFViewFs_Prod_FabricantesEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_FabricantesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_FabricantesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Fs_Prod_FabricantesDataset.Connection.Model.DefaultSchema.FindEntityType(
      Fs_Prod_FabricantesDataset.EntitySetName
    )
  );
  XDataClientFs_Prod_FabricantesGet.Get(Fs_Prod_FabricantesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFs_Prod_FabricantesEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(Fs_Prod_FabricantesDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      ednome.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewFs_Prod_FabricantesEdit.XDataClientFs_Prod_FabricantesGetLoad(Response: TXDataClientResponse);
begin
  Fs_Prod_FabricantesDataset.Close;
  Fs_Prod_FabricantesDataset.SetJsonData(Response.Result);
  Fs_Prod_FabricantesDataset.Open;
  
  Fs_Prod_FabricantesDataset.Edit;  
end;

procedure TFViewFs_Prod_FabricantesEdit.Fs_Prod_FabricantesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Fs_Prod_FabricantesDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewFs_Prod_FabricantesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFs_Prod_FabricantesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fs_prod_fabricantes.form.lbid');
  lbnome := TLabel.Create('view.fs_prod_fabricantes.form.lbnome');
  lbexcluido := TLabel.Create('view.fs_prod_fabricantes.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fs_prod_fabricantes.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fs_prod_fabricantes.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fs_prod_fabricantes.form.lbexclusao');
  btCancel := TButton.Create('view.fs_prod_fabricantes.form.btBack');
  btSave := TButton.Create('view.fs_prod_fabricantes.form.btSave');
  edid := TDBEdit.Create('view.fs_prod_fabricantes.form.edid');
  ednome := TDBEdit.Create('view.fs_prod_fabricantes.form.ednome');
  edinclusao := TDBEdit.Create('view.fs_prod_fabricantes.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fs_prod_fabricantes.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fs_prod_fabricantes.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.fs_prod_fabricantes.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Fs_Prod_FabricantesDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_FabricantesDatasetid := TIntegerField.Create(Self);
  Fs_Prod_FabricantesDatasetnome := TStringField.Create(Self);
  Fs_Prod_FabricantesDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_FabricantesDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_FabricantesDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_FabricantesDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFs_Prod_FabricantesGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDataset.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetid.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_FabricantesDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFs_Prod_FabricantesGet.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_FabricantesEdit';
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 5;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.MaxLength := 255;
    ednome.TabOrder := 6;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 8;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 9;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 10;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 243;
    cbExcluido.Width := 113;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Fs_Prod_FabricantesDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Fs_Prod_FabricantesDataset.SetParentComponent(Self);
    Fs_Prod_FabricantesDataset.Name := 'Fs_Prod_FabricantesDataset';
    Fs_Prod_FabricantesDataset.AfterApplyUpdates := Fs_Prod_FabricantesDatasetAfterApplyUpdates;
    Fs_Prod_FabricantesDataset.EntitySetName := 'Fs_Prod_Fabricantes';
    Fs_Prod_FabricantesDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_FabricantesDataset.Left := 176;
    Fs_Prod_FabricantesDataset.Top := 8;
    Fs_Prod_FabricantesDatasetid.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetid.Name := 'Fs_Prod_FabricantesDatasetid';
    Fs_Prod_FabricantesDatasetid.FieldName := 'id';
    Fs_Prod_FabricantesDatasetnome.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetnome.Name := 'Fs_Prod_FabricantesDatasetnome';
    Fs_Prod_FabricantesDatasetnome.FieldName := 'nome';
    Fs_Prod_FabricantesDatasetnome.Required := True;
    Fs_Prod_FabricantesDatasetnome.Size := 255;
    Fs_Prod_FabricantesDatasetexcluido.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetexcluido.Name := 'Fs_Prod_FabricantesDatasetexcluido';
    Fs_Prod_FabricantesDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_FabricantesDatasetinclusao.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetinclusao.Name := 'Fs_Prod_FabricantesDatasetinclusao';
    Fs_Prod_FabricantesDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_FabricantesDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_FabricantesDatasetalteracao.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetalteracao.Name := 'Fs_Prod_FabricantesDatasetalteracao';
    Fs_Prod_FabricantesDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_FabricantesDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_FabricantesDatasetexclusao.SetParentComponent(Fs_Prod_FabricantesDataset);
    Fs_Prod_FabricantesDatasetexclusao.Name := 'Fs_Prod_FabricantesDatasetexclusao';
    Fs_Prod_FabricantesDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_FabricantesDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientFs_Prod_FabricantesGet.SetParentComponent(Self);
    XDataClientFs_Prod_FabricantesGet.Name := 'XDataClientFs_Prod_FabricantesGet';
    XDataClientFs_Prod_FabricantesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFs_Prod_FabricantesGet, Self, 'OnLoad', 'XDataClientFs_Prod_FabricantesGetLoad');
    XDataClientFs_Prod_FabricantesGet.Left := 64;
    XDataClientFs_Prod_FabricantesGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Fs_Prod_FabricantesDataset.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetid.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetnome.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_FabricantesDatasetexclusao.AfterLoadDFMValues;
    XDataClientFs_Prod_FabricantesGet.AfterLoadDFMValues;
  end;
end;

end.
